import React, { useEffect, useState } from 'react';
import { Link, useHistory, useLocation } from 'react-router-dom';
import { confirmStripeReturn } from '../services/agendaService';
import '../styles/agenda.css';

const leerParametro = (search, nombre) => {
  const query = String(search || '').replace(/^\?/, '');
  const partes = query.split('&');

  for (let i = 0; i < partes.length; i += 1) {
    const par = partes[i].split('=');
    const clave = decodeURIComponent(par[0] || '');

    if (clave === nombre) {
      return decodeURIComponent((par[1] || '').replace(/\+/g, ' '));
    }
  }

  return '';
};

const estadoCalendario = (datos, extra) => {
  const presencial = datos.modalidad === 'presencial';
  const especialistaId = Number(datos.especialista_id) || 0;
  const documento = datos.documento || datos.terapia_documento || '';

  if (presencial && !documento) {
    return null;
  }

  if (!presencial && !especialistaId) {
    return null;
  }

  return {
    pathname: '/agenda/calendario',
    state: {
      modality: presencial
        ? { id: 'presencial', label: 'Presencial' }
        : { id: 'online', label: 'Terapia Online' },
      specialist: presencial
        ? {
            cedula: documento,
            sede: datos.sede || '',
            label: '',
          }
        : {
            id: especialistaId,
            label: '',
          },
      location: datos.sede ? { id: datos.sede, label: datos.sede } : undefined,
      ...(extra || {}),
    },
  };
};

const AgendaStripeReturnPage = () => {
  const history = useHistory();
  const location = useLocation();
  const resultado = leerParametro(location.search, 'resultado');
  const sessionId = leerParametro(location.search, 'session_id');
  const [estado, setEstado] = useState(resultado === 'cancelado' ? 'cancelado' : 'cargando');
  const [mensaje, setMensaje] = useState('');

  useEffect(() => {
    if (resultado === 'cancelado') {
      const destino = estadoCalendario({
        modalidad: leerParametro(location.search, 'modalidad'),
        especialista_id: leerParametro(location.search, 'especialista_id'),
        documento: leerParametro(location.search, 'documento'),
        sede: leerParametro(location.search, 'sede'),
      });

      if (destino) {
        history.replace(destino);
      }

      return undefined;
    }

    if (!sessionId) {
      setEstado('error');
      setMensaje('No se recibió la confirmación del pago.');
      return undefined;
    }

    let vigente = true;

    confirmStripeReturn(sessionId)
      .then((data) => {
        if (!vigente) {
          return;
        }

        const destino = estadoCalendario(data || {}, {
          pagoStripe: true,
          slotPagado: {
            fecha: data && data.fecha,
            hora: data && data.hora,
          },
        });

        if (destino) {
          history.replace(destino);
          return;
        }

        setEstado('pagada');
      })
      .catch((error) => {
        if (!vigente) {
          return;
        }

        setMensaje(error.message || 'No se pudo confirmar el pago.');
        setEstado('error');
      });

    return () => {
      vigente = false;
    };
  }, [history, location.search, resultado, sessionId]);

  let titulo = 'Confirmando el pago…';
  let texto = 'Espera un momento. Enseguida verás el calendario.';

  if (estado === 'pagada') {
    titulo = 'Pago recibido';
    texto = 'La cita quedó pagada. En el calendario se verá en verde.';
  }

  if (estado === 'cancelado') {
    titulo = 'Pago no realizado';
    texto = 'No se hizo ningún cobro. Puedes volver a la agenda para pagar la cita.';
  }

  if (estado === 'error') {
    titulo = 'No se pudo confirmar el pago';
    texto = mensaje;
  }

  return (
    <div className="agenda-root agenda-root--booking">
      <section className="agenda-booking">
        <div className="agenda-payment-card">
          <h1>{titulo}</h1>
          <p>{texto}</p>
          {estado !== 'cargando' ? (
            <Link to="/agenda" className="agenda-calendar-back">
              ← Volver a la agenda
            </Link>
          ) : null}
        </div>
      </section>
    </div>
  );
};

export default AgendaStripeReturnPage;
